export default __webpack_public_path__ + "static/media/Icons_Trash_Regular.d3cf9254.svg";